import {
    Home,
    MapPin,
    Calendar,
    BookOpen,
    Heart,
    Video,
    Image as ImageIcon,
    Info,
    Mail,
    type LucideIcon,
} from "lucide-react";

export interface PrimaryNavItem {
    id: string;
    labelKey: string;
    path: string;
    icon: LucideIcon;
}

export interface SecondaryNavItem {
    id: string;
    labelKey: string;
    path: string;
    icon: LucideIcon;
    descriptionKey?: string;
}

// Configurable primary navigation slots (4 primary pages)
export const DEFAULT_PRIMARY_NAV: PrimaryNavItem[] = [
    { id: "home", labelKey: "nav.home", path: "/", icon: Home },
    { id: "visit", labelKey: "nav.visit", path: "/visit", icon: MapPin },
    { id: "events", labelKey: "nav.events", path: "/events", icon: Calendar },
    { id: "resources", labelKey: "nav.resources", path: "/resources", icon: BookOpen },
];

// Secondary items shown in the "More" bottom sheet
// Note: /benevolence is intentionally excluded from public nav (exclusive to church members via direct link)
export const SECONDARY_NAV_ITEMS: SecondaryNavItem[] = [
    { id: "giving", labelKey: "nav.giving", path: "/giving", icon: Heart },
    { id: "videos", labelKey: "nav.videos", path: "/videos", icon: Video },
    { id: "gallery", labelKey: "nav.gallery", path: "/gallery", icon: ImageIcon },
    { id: "about", labelKey: "nav.about", path: "/about", icon: Info },
    { id: "contact", labelKey: "nav.contact", path: "/contact", icon: Mail },
];

export const isRouteActive = (currentPath: string, targetPath: string): boolean => {
    if (targetPath === "/") {
        return currentPath === "/";
    }
    return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
};

/**
 * Returns true if the user is on an individual resource/study reader page (e.g. /resources/:slug).
 * Used to suppress the generic mobile bottom dock in favor of the immersive reader experience
 * which has its own dedicated "<- Back to Resources" button and study pagination dock.
 */
export const isStudyReaderRoute = (pathname: string): boolean => {
    const clean = pathname.replace(/\/+$/, "");
    return clean.startsWith("/resources/") && clean !== "/resources";
};
